import { useEffect } from 'react';

import { telemetryNoticeError } from './useTelemetry';

export const useLoadScript = (url: string) => {
  useEffect(() => {
    const script = document.createElement('script');

    script.src = url;
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);

    return () => {
      try {
        document.body.removeChild(script);
      } catch (e) {
        telemetryNoticeError(e, 'Error while removing script in useLoadScript');
      }
    };
  }, [url]);

  return null;
};
